import { ObjectUtil } from "@mcleod/core";
import { Component } from "./Component";
import { ComponentPropDefinitions, ComponentPropDefinitionUtil, ComponentProps } from "./ComponentProps";
import { PropType } from "./PropType";

export interface ContainerProps extends ComponentProps {
    components?: Component[];
}

let containerPropDefs: ComponentPropDefinitions;

export class ContainerPropDefinitions {
    public static getDefinitions(): ComponentPropDefinitions {
        if (containerPropDefs == null) {
            containerPropDefs = {
                ...ComponentPropDefinitionUtil.getComponentPropertyDefinitions(),
                ...this.buildEventProps()
            };
            ComponentPropDefinitionUtil.populateComponentPropNames(containerPropDefs);
        }
        return containerPropDefs;
    }

    private static buildEventProps(): ComponentPropDefinitions {
        return {
            onContentsChanged: {
                type: PropType.event,
                category: "Events",
                addListenerMethod: "addContentsChangedListener",
                removeListenerMethod: "removeContentsChangedListener",
                eventSignature: "OnContentsChanged(event: ContainerContentsChangedEvent)",
                description: "This specifies a function to be called when one or more components is added to, or removed from, the container."
            }
        };
    }
}

export class ContainerPropDefinitionUtil {
    public static getContainerPropertyDefinitions(): ComponentPropDefinitions {
        return ObjectUtil.deepCopy(ContainerPropDefinitions.getDefinitions());
    }
}
